export default "__VITE_ASSET__CxClsyyX__"